import { Product } from "gen/product/models_pb"
import {
  Transfer_Product as TransferProduct,
  Transfer_Status as TransferStatus,
} from "gen/txn/models_pb"
import { UUID } from "shared-ts/classes/uuid"

export const productFromTransferProduct = (
  productsById: { [id: string]: Product },
  product: TransferProduct
) => productsById[UUID.fromPB(product.productId!).toString()]

export function getPreviousLinkTitle(status?: TransferStatus) {
  switch (status) {
    case TransferStatus.SENT:
      return "Sent"
    case TransferStatus.RECEIVED:
      return "Received"
    case TransferStatus.VOIDED:
      return "Voided"
    case TransferStatus.REQUESTED:
      return "Requested"
    default:
      return "Drafts"
  }
}

export function getPreviousLinkPath(status?: TransferStatus) {
  switch (status) {
    case TransferStatus.CREATED:
      return "drafts"
    case TransferStatus.SENT:
      return "sent"
    case TransferStatus.RECEIVED:
      return "received"
    case TransferStatus.VOIDED:
      return "voided"
    case TransferStatus.REQUESTED:
      return "requested"
    default:
      return "new"
  }
}
